document.addEventListener("DOMContentLoaded", () => {

    const descripcion = document.querySelector(".descripcion-producto");
    const tabla = descripcion.querySelector("table");

    if(!tabla) return;

    const filas = tabla.querySelectorAll("tr");

    // IGNORAR HEADER
    filas.forEach((fila, index) => {

        if(index === 0) return;

        const columnas = fila.querySelectorAll("td");

        if(columnas.length < 4) return;

        const pieza = columnas[0].innerText.trim();
        const largo = columnas[1].innerText.trim();
        const alto = columnas[2].innerText.trim();
        const ancho = columnas[3].innerText.trim();

        const tarjeta = document.createElement("div");

        tarjeta.classList.add("item-medida-producto");

        tarjeta.innerHTML = `
        
            <p class="titulo-medida-producto">
                ${pieza}
            </p>

            <div class="contenedor-datos-medida-producto">

                <div>
                    <span>Largo</span>
                    <p>${largo}</p>
                </div>

                <div>
                    <span>Alto</span>
                    <p>${alto}</p>
                </div>

                <div>
                    <span>Ancho</span>
                    <p>${ancho}</p>
                </div>

            </div>

        `;

        document
            .getElementById("grid-medidas-producto")
            .appendChild(tarjeta);

    });

});